import React from 'react';
import {
  Button,
  LoadingButton,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Typography,
} from '@one-thd/sui-atomic-components';
import { IModalBasicProps } from '../../../models/common/modal';

export interface IStopAllAuthProps {
  onConfirmStopAllAuth: () => void;
  isLoading: boolean;
  onClickNo: () => void;
  hasBenefit?: boolean;
}

export const StopAllAuthModal = ({
  hideModal,
  onConfirmStopAllAuth,
  isLoading,
  onClickNo,
  hasBenefit,
}: IStopAllAuthProps & IModalBasicProps) => {
  return (
    <>
      <ModalHeader onClose={hideModal}>
        Stop Remote Purchases For All Credit Cards
      </ModalHeader>
      <ModalBody>
        <Typography variant="body-base" weight="bold">
          Are you sure you want to stop remote purchases for all credit cards on
          your account?
        </Typography>
        <br />
        <p className="stop-all-auth-modal-text sui-text-base">
          You&apos;ll no longer be able to complete the following actions from
          any credit card on your account:
          <br />
          <br />
          <ul className="sui-list-disc sui-ml-6">
            <li>Approve in-store purchases via Phone Sale</li>
            <li>Approve in-store purchases via Text2Confirm</li>
            {hasBenefit && (
              <li>Assign Pro Allowances and use existing Pro Allowances</li>
            )}
          </ul>
        </p>
      </ModalBody>
      <ModalFooter position="end">
        <div className="sui-flex sui-gap-4 sm:sui-gap-4 sui-flex-col-reverse sui-w-full sm:sui-flex-row sm:sui-w-auto">
          <Button variant="secondary" onClick={onClickNo}>
            No
          </Button>
          <LoadingButton
            loading={isLoading}
            variant="primary"
            onClick={onConfirmStopAllAuth}
            data-testid="stop-auth-all-cards-btn"
          >
            Yes, Stop for All Cards
          </LoadingButton>
        </div>
      </ModalFooter>
    </>
  );
};

StopAllAuthModal.displayName = 'StopAllAuthModal';
